import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCliente } from "../../actions/clientes";
import { GotoLogin } from "../../actions/renovarLog";
import style from "../../styles/grid.module.css";
import { Pencil, SquareX, CirclePlus } from "lucide-react";

export default function Cliente() {
   const navigate = useNavigate();
   const { GetClientes, DeleteCliente } = useCliente();
   const data = GetClientes();
   const [nombre, setName] = useState("");

   function handleInputChange(e) {
      if (e.key === "Enter") {
         // dispatch(getClientesByName(usr, nombre));
         console.log("clientes: ", nombre);
         setName("");
      }
   }

   const handleRemove = async (id) => {
      let text =
         "Se va a eliminar el Cliente selecionado!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         await DeleteCliente.mutateAsync(id);
         navigate("/clientes");
      }
   };

   if (data?.message === "Token inválido") {
      return <GotoLogin />;
   }

   console.log("data: ", data);
   return (
      <div className={style.tableCli}>
         <div>
            <div>
               <div className={style.gridTitle}>
                  <h2>Clientes</h2>
               </div>
            </div>
            <div>
               <div>
                  <Link
                     to={"/formCliente"}
                     className="dLink"
                     title="Alta Cliente"
                     state={{
                        id_primary: 0,
                        id: 0,
                        companyId: 0,
                        nombre: "",
                        email: "",
                        tewlefono: 0,
                        cod_status: 1,
                        documento: "",
                        
                     }}
                  >
                     {" "}
                     <CirclePlus className="lucidePlus" />
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
         </div>
         <br />
         <div>
            <table className={style.gridTable}>
               <thead>
                  <tr className={style.trBuscar}>
                     <th>Buscar</th>
                     <th className={style.thCli}>
                        <input
                           onKeyPress={(e) => handleInputChange(e)}
                           onChange={(e) => setName(e.target.value)}
                           type="text"
                           id="search-navbar"
                           placeholder="Buscar..."
                           value={nombre}
                        />
                     </th>
                     <th className={style.thCli}></th>
                     <th>&nbsp;</th>
                  </tr>
                  <tr className={style.trTitle}>
                     <th className={style.title}>Nombre</th>
                     <th className={style.title2}>E-Mail</th>
                     <th className={style.title2}>Telefono</th>
                     <th className={style.title2}>Documento</th>
                     <th className={style.tdaccions}>Acciones</th>
                  </tr>
               </thead>
               <tbody>
                  {data?.length > 0 &&
                     data?.map((cli, i) => {
                        var muestroreg = true;
                        if (nombre !== "") {
                           if (
                              cli.nombre
                                 .toUpperCase()
                                 .includes(nombre.toUpperCase())
                           ) {
                              muestroreg = true;
                           } else {
                              muestroreg = false;
                           }
                        }
                        if (muestroreg) {
                           return (
                              <tr
                                 key={i}
                                 className={
                                    parseInt(cli.cod_status) === 2
                                       ? style.trdatosRed
                                       : style.trdatos
                                 }
                              >
                                 <td className={style.style_td}>
                                    {cli.nombre}
                                 </td>
                                 <td className={style.style_email}>
                                    {cli.email}
                                 </td>
                                 <td className={style.style_email}>
                                    {cli.telefono}
                                 </td>
                                 <td className={style.style_email}>
                                    {cli.documento}
                                 </td>
                                 <td className={style.tdaccions}>
                                    <Link
                                       title="Editar Cliente"
                                       to={"/formCliente"}
                                       state={{
                                          id_primary: cli.id_primary,
                                          id: cli.id,
                                          companyId: cli.companyId,
                                          nombre: cli.nombre,
                                          email: cli.email,
                                          telefono: cli.telefono,
                                          fecha_nacimiento: cli.fecha_nacimiento,
                                          cod_status: cli.cod_status,
                                          documento: cli.documento,
                                       }}
                                    >
                                       <Pencil className="lucideIcon" />
                                    </Link>
                                    &nbsp;&nbsp;
                                    <span
                                       className="lucideIconDel"
                                       title="Eliminar cliente"
                                    >
                                       <SquareX
                                          className="lucideIconDel"
                                          onClick={() => handleRemove(cli.id)}
                                       />
                                    </span>
                                 </td>
                              </tr>
                           );
                        } else {
                           return null;
                        }
                     })}
               </tbody>
            </table>
         </div>
      </div>
   );
}
